import React, { FunctionComponent, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { MItem } from "../../components/common/GameHeader/GameHeader";
import { GameHeader } from "../../components/common/GameHeader/GameHeader";
import "../../App.scss";
import kryptosLogo from "../../assets/kryptosc_500.png";
import KryptosPlay from "./KryptosPlay/KryptosPlay";
import KryptosRules from "./KryptosRules/KryptosRules";
import KryptosRanklist from "./KryptosRanklist/KryptosRanklist";

type Props = {
  match: any;
};

function detectMob() {
  return window.innerWidth <= 1000;
}

const Kryptos: FunctionComponent<Props> = (props) => {
  const [showRanklist, setShowRanklist] = React.useState(false);
  // useEffect(() => {
  //   console.log("RLShow", showRanklist)
  // })
  const { match } = props;
  return (
    <div
      style={{
        maxHeight: "100vh",
        overflow: "hidden",
        backgroundImage:
          "linear-gradient(rgb(79, 53, 104), rgb(36, 37, 96)), url(/assets/particles.png)",
        backgroundBlendMode: "overlay",
        backgroundSize: "cover",
        fontFamily: '"Space Grotesk", serif',
        backgroundRepeat: "no-repeat",
        height: "100vh",
      }}
      className="gameheader-content"
    >
      <GameHeader gName="KRYPTOS" icon={kryptosLogo}>
        <MItem text="Play" link="/Kryptos" />
        <MItem text="Rules" link="/Kryptos/rules" />
        {detectMob() ? (
          <MItem text="Ranklist" link="/Kryptos/ranklist" />
        ) : (
          <li className="nav-item">
            <a
              className="nav-link active"
              onClick={(e) => {
                setShowRanklist(!showRanklist);
              }}
            >
              <span className="link-rotate">{"Ranklist"}</span>
            </a>
          </li>
        )}
      </GameHeader>
      <Switch>
        <Route
          exact
          path={`${match.url}/`}
          render={() => <KryptosPlay showRanklist={showRanklist} />}
        />
        <Route exact path={`${match.url}/rules`} component={KryptosRules} />
        <Route
          exact
          path={`${match.url}/ranklist`}
          component={KryptosRanklist}
        />

        {/* commented out 
        
       




         <Route
          exact
          path="/ranklist"
          component={KryptosRanklist}
        /> 
        
        <Route exact path="/Kryptos" render={() => <KryptosPlay showRanklist={showRanklist} />} /> */}
      </Switch>
    </div>
  );
};

//export default withLogin(Kryptos);

export default Kryptos;
